import { BACKEND_PROVIDER } from './config';
import { backend as supabaseBackend } from './providers/supabase';

// Backend selection is deliberately isolated here. Application features do
// not select or import a backend vendor. Add another provider adapter and
// select it here (or via VITE_BACKEND_PROVIDER) without changing feature code.
const providers = {
  supabase: supabaseBackend,
};

const backend = providers[BACKEND_PROVIDER];

if (!backend) {
  throw new Error(
    `[DrillLogPro] Unsupported backend provider "${BACKEND_PROVIDER}". ` +
    `Add an adapter under src/backend/providers and register it in src/backend/index.js.`
  );
}

export { backend };
export const backendKind = backend.kind;
export const { entities, auth, functions, integrations, db, cloud, device, authClient } = backend;
